module.exports = __webpack_public_path__ + "img/coding-pending.a27d962b.gif";